import React from 'react';
import ScoreTrendWidget from '../components/widgets/ScoreTrendWidget';
import PersonalRecordsWidget from '../components/widgets/PersonalRecordsWidget';
import TopWordsWidget from '../components/TopWordsWidget';
import TopLongestWordsWidget from '../components/TopLongestWordsWidget';
import EconomyWidget from '../components/widgets/EconomyWidget';
import WordcraftWidget from '../components/widgets/WordcraftWidget';
import BagTasteWidget from '../components/widgets/BagTasteWidget';
import RunsWidget from '../components/widgets/RunsWidget';
import LetterFrequencyWidget from '../components/widgets/LetterFrequencyWidget';
import ShopTendenciesWidget from '../components/widgets/ShopTendenciesWidget';

function TopWordsFromStats({ stats }) {
  const topWordPlays = Array.isArray(stats?.history?.topWordPlays)
    ? stats.history.topWordPlays.slice(0, 5)
    : [];
  return <TopWordsWidget topWordPlays={topWordPlays} />;
}

function TopLongestWordsFromStats({ stats }) {
  const topLongestWordPlays = Array.isArray(stats?.history?.topLongestWordPlays)
    ? stats.history.topLongestWordPlays.slice(0, 5)
    : [];
  return <TopLongestWordsWidget topLongestWordPlays={topLongestWordPlays} />;
}

export const HOME_WIDGETS = [
  {
    id: 'score-trend',
    label: 'Score Trend',
    description: 'Line chart of your last 20 run scores with average overlay',
    defaultEnabled: true,
    Component: ScoreTrendWidget,
  },
  {
    id: 'personal-records',
    label: 'Personal Records',
    description: 'Your all-time bests: best word, longest word, best submit, and more',
    defaultEnabled: true,
    Component: PersonalRecordsWidget,
  },
  {
    id: 'top-words',
    label: 'Your Top Words',
    description: 'Top 5 highest-scoring words ever played',
    defaultEnabled: true,
    Component: TopWordsFromStats,
  },
  {
    id: 'top-longest-words',
    label: 'Your Longest Words',
    description: 'Top 5 longest words ever played',
    defaultEnabled: true,
    Component: TopLongestWordsFromStats,
  },
  {
    id: 'economy',
    label: 'Economy',
    description: 'Wins, shop visits, targets reached, and round stats',
    defaultEnabled: false,
    Component: EconomyWidget,
  },
  {
    id: 'wordcraft',
    label: 'Wordcraft',
    description: 'Words submitted, submits used, discards, and more',
    defaultEnabled: false,
    Component: WordcraftWidget,
  },
  {
    id: 'bag-taste',
    label: 'Your Bag Taste',
    description: 'How often you play each starting bag preset',
    defaultEnabled: false,
    Component: BagTasteWidget,
  },
  {
    id: 'runs',
    label: 'Runs',
    description: 'Recent and best run history',
    defaultEnabled: false,
    Component: RunsWidget,
  },
  {
    id: 'letter-frequency',
    label: 'Letter Frequency',
    description: 'How often each letter appears in your submitted words',
    defaultEnabled: false,
    Component: LetterFrequencyWidget,
  },
  {
    id: 'shop-tendencies',
    label: 'Shop Tendencies',
    description: 'Your shop selection patterns by type and rarity',
    defaultEnabled: false,
    Component: ShopTendenciesWidget,
  },
];

export const HOME_WIDGET_DEFAULT_ENABLED_IDS = HOME_WIDGETS.filter((w) => w.defaultEnabled).map(
  (w) => w.id
);
